import { Routing, getSchemeAndAuthority } from "@timesheets/webapp-support";

import { GemmaError } from "@gemma/errors";
import { IGroupRoute } from "./IGroupRoute";
import { IState } from "../vuex/IState";
import { PageTypes } from "./PageTypes";
import { Protocols } from "@gemma/typescript-types";
import { Route } from "@gemma/utils";
import { Store } from "vuex";
import { TRouteMetaGroup } from "./TRouteMetaGroup";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { ensureRoleForRoute } from "./ensureRoleForRoute";
import { redirectToRolesList } from "./redirectToRolesList";

export function handlePages(pageType: PageTypes, store: Store<IState>, onRouteResult: (routeResult: Routing.RouteResult<TRouteMetaGroup>) => Routing.RouteResult<TRouteMetaGroup> = routeResult => routeResult) {
  return function resolveCorrectPage(to: string | IGroupRoute, from: IGroupRoute): Routing.RouteResult<TRouteMetaGroup> {
    let routeResult: Routing.RouteResult<TRouteMetaGroup> | undefined = undefined;
    let fullPath: string | undefined = undefined;
    if (typeof to === "string") {
      const withoutScheme = to.split("//")[1];
      const pathStartsAt = withoutScheme.indexOf("/");
      const domain = withoutScheme.split(":")[0];
      fullPath = withoutScheme.substring(pathStartsAt);

      if (!to.startsWith(Protocols.HTTPS)) {
        if (domain.endsWith("savetrees.co.uk") && domain !== window.location.hostname) {
          routeResult = { continue: false, route: new Route(fullPath), location: { action: Routing.RouteAction.Assign, schemeAndAuthority: getSchemeAndAuthority(WebApplicationConstants, domain) } };
        } else {
          throw new GemmaError("Only redirecting to a SaveTrees website is permitted", { data: { to, from } });
        }
      }
    }

    if (!routeResult) {
      if (typeof to === "string") {
        to = new Route(fullPath as string);
      }

      if (from.meta && from.meta.group && to.meta && to.meta.group !== from.meta.group) {
        routeResult = { continue: false, route: to, location: { action: Routing.RouteAction.Assign, schemeAndAuthority: getSchemeAndAuthority(WebApplicationConstants) } };
      } else {
        if (store.state.currentSession.account.isLoggedIn) {
          routeResult = ensureRoleForRoute(to, pageType, store);
          if (pageType === PageTypes.AccountPages) {
            if (routeResult.route) {
              routeResult = redirectToRolesList(pageType, routeResult.route);
              routeResult.location = { action: Routing.RouteAction.Assign, schemeAndAuthority: getSchemeAndAuthority(WebApplicationConstants) };
            }
          } else if (pageType === PageTypes.Dashboard) {
            const fullPath = (routeResult.route && routeResult.route.fullPath) || to.fullPath;

            if (fullPath.startsWith("/login") && (!routeResult || (routeResult && routeResult.continue))) {
              routeResult = redirectToRolesList(pageType, routeResult && routeResult.route ? routeResult.route : to);
            }
          } else {
            throw new GemmaError(`Unknown PageType "${pageType}"`, { sensitive: true, system: true, ui: false, data: { pageType } });
          }
        } else {
          document.cookie = WebApplicationConstants.authCookie.value;
          document.cookie = WebApplicationConstants.authCookie.sig;
          store.dispatch("user/setCurrentRole");
          if (pageType === PageTypes.AccountPages) {
            routeResult = { continue: true, route: undefined };
          } else {
            routeResult = Routing.setLoginRoute<TRouteMetaGroup>(to, WebApplicationConstants);
          }
        }
      }
    }

    return onRouteResult(routeResult);
  };
}
